import { useEffect } from 'react';

import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';
import { useProfileManager } from '@/shared/hooks/useProfileManager';

export const useRegisterAnalytics = () => {
    const { isNewlyRegisteredUser } = useProfileManager();
    const sendWebAnalytics = useSendWebAnalytics();

    useEffect(() => {
        if (isNewlyRegisteredUser) {
            sendWebAnalytics('REGISTRATION_SUCCESS');
        }
    }, [isNewlyRegisteredUser, sendWebAnalytics]);
};
